
import {ComplaintList} from"./List"
import {ComplaintView} from "./View"

export {ComplaintView, ComplaintList}